'use client'

import { useState, useEffect } from 'react'

function AlphaDialogContent({ onAcknowledge }) {
    return (
        <div 
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[99999]"
            style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0 }}
        >
            <div className="bg-white p-6 rounded-lg max-w-md relative z-[100000]">
                <h2 className="text-xl font-bold mb-4">Alpha Version Notice</h2>
                <p className="mb-4">
                    Welcome to Autofocus! Please note that this application is currently in a very early alpha stage. 
                    The current functionality and features are not representative of the final production version.
                    NOTE: for the time being - SIGN-UPs are DISABLED. Please reach out to Nate if you want to claim your
                    autofoc.us handle. 
                </p>
                <button
                    onClick={onAcknowledge}
                    className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                >
                    I Understand
                </button>
            </div>
        </div>
    )
}

export default function AlphaDialog() {
    const [showDialog, setShowDialog] = useState(true)
    const [isMounted, setIsMounted] = useState(false)

    useEffect(() => {
        setIsMounted(true)
        const hasAcknowledged = localStorage.getItem('alphaAcknowledged')
        if (hasAcknowledged === 'true') {
            setShowDialog(false)
        }
    }, [])

    const handleAcknowledge = () => {
        localStorage.setItem('alphaAcknowledged', 'true')
        setShowDialog(false)
    }

    if (!isMounted) {
        return null
    }

    if (showDialog) {
        return <AlphaDialogContent onAcknowledge={handleAcknowledge} />
    }

    return null
}
